import React from "react";
import { services, socialIcons, team, availRoomSample } from "../data/Data";
import { Link, NavLink } from "react-router-dom";
import CommonHeading from "../common/CommonHeading";
import { FaRupeeSign } from "react-icons/fa";

export default function SampleRoom() {
  return (
    <>
      <div className="container py-5 px-0">
        <div className="">
          <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
            <h6 className="section-title text-center text-warning text-uppercase">
              OUR ROOM PRICES
            </h6>
            <h1 className="mb-5">
              The Best Room
              <span className="text-warning text-uppercase"> Prices</span>
            </h1>
          </div>

          <div className="row g-4">
            {availRoomSample.map((room, index) => (
              <div
                className="col-lg-4 col-md-6 wow fadeInUp text-center"
                data-wow-delay="0.1s"
                key={index}
              >
                <div className=" room-item room-item-sample shadow rounded overflow-hidden py-5">
                  <h3>{room.roomType}</h3>
                  <h6>
                    <FaRupeeSign /> {room.roomPrice}
                  </h6>
                  <p className="p-3">{room.description}</p>
                  <NavLink to={"/rooms"}>
                    <button
                      className="btn btn-primary-custom col-md-8 col-6"
                      type="button"
                    >
                      More Info
                    </button>
                  </NavLink>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
